import { apiClient, type ApiClientResponse, routes } from 'common/services';

export const getUserExists = async (params: { email?: string; phone?: string }) =>
  apiClient.get<undefined, ApiClientResponse<undefined>>(routes.user.exists, { params });
